import classNames from 'classnames/bind';
import React from 'react';
import styles from './HeaderIconsContainer.scss';
import type { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import { useHeaderState } from '../context/HeaderContext';

export interface HeaderIconsContainerProps {
    rightAligned?: boolean;
    content?: JSX.Element[];
    className?: string;
    colorScheme?: ColorScheme;
    tabIndex?: number;
}

const cx = classNames.bind(styles);

export const HeaderIconsContainer = (props: HeaderIconsContainerProps) => {
    const { content, rightAligned = false, className } = props;
    const { titleAlign } = useHeaderState();

    return (
        <div
            className={cx(
                styles.iconsContainer,
                titleAlign === 'center' && styles.titleCenter,
                rightAligned && styles.rightAligned,
                className
            )}>
            {content}
        </div>
    );
};
